import React, { useContext, useEffect } from 'react'; //eslint-disable-line
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import addSeconds from 'date-fns/add_seconds';
import differenceInSeconds from 'date-fns/difference_in_seconds';
import { useTranslation } from 'react-i18next';

import locationStoreContext from '../stores/locationStore';
import viewStoreContext from '../stores/viewStore';
import OccupancyDetail from '../components/OccupancyDetail';
import StationHeader from '../components/StationHeader';
import TripDirectionHeader from '../components/TripDirectionHeader';
import goTrackerConfig from 'goTrackerConfig';
import utils from '../utils';
import * as CONSTS from '../utils/constants';
import '../i18n';
import HeaderColumns from './HeaderColumns';
import TagItem from './TagItem';

const Detail = observer(props => {
  const locationStore = useContext(locationStoreContext);
  const viewStore = useContext(viewStoreContext);
  const location = useLocation();
  const { t } = useTranslation();

  const departureClass = props.departureClass ? props.departureClass : '';

  // useEffect(() => {
  //   locationStore.resetTripDetail();
  // }, []);
  const loadPage = () => {
    const { corridor, station, tripNumber } = props.params;
    if (utils.isNullOrEmpty(corridor) || utils.isNullOrEmpty(station) || utils.isNullOrEmpty(tripNumber)) return;

    locationStore.setCorridor(corridor);
    locationStore.setStation(station);
    locationStore.loadTripsByCorridorAndStation();
    locationStore.loadTrip(tripNumber);
  };

  useEffect(() => {
    console.log('hook fire');
    viewStore.updateView(CONSTS.VIEW_PATHS.TRIP_DETAIL);
  }, []);

  useEffect(() => {
    loadPage();

    const interval = setInterval(() => {
      locationStore.loadTripsByCorridorAndStation();
      locationStore.loadTrip();

      if (goTrackerConfig.debug) {
        viewStore.updateAutoRefreshTime();
      }
    }, goTrackerConfig.autoRefreshRate || 10000);
    return () => clearInterval(interval);
  }, [locationStore.corridors]);

  //Refactor
  const headerCol = props.headerCol;

  const _tripNumber = locationStore.trip ? locationStore.trip.tripNumber : '';

  const isStationCurrent = stopName => {
    if (locationStore.station && locationStore.station.name === stopName) {
      return true;
    }

    return false;
  };

  /**Gets the estimated delay time of the trip using actual - scheduled arrival times */
  const getEstimatedTripDelay = tripNumber => {
    // If user accessed this page using the controls we would have the delay time from the departure page
    if (location.state && location.state.delayTime) {
      return location.state.delayTime;
    }

    if (!locationStore.messages) return 0;

    const tripMessages = locationStore.messages.directions.map(d => d.tripMessages);
    const mergedTripMessages = [].concat.apply([], tripMessages);
    const trip = mergedTripMessages.find(tm => tm.tripName === tripNumber.toString());

    return trip !== undefined ? differenceInSeconds(trip.actual, trip.scheduled) : 0;
  };

  const getDirectionByNumber = tripNumber => {
    if (!tripNumber) return null;

    let direction = null;

    if (locationStore.messages && locationStore.messages.directions) {
      locationStore.messages.directions.forEach(d => {
        if (d.tripMessages.length < 1) return;

        const index = d.tripMessages.findIndex(trip => trip.tripName === tripNumber);

        if (index > -1) {
          direction = d.direction;
        }
      });
    }
    return direction;
  };

  /**Gets the status of the each stop (on time, cancelled, not stopping, delay) */
  const getDelayTime = (stop, tripDelay) => {
    let status = '';
    let statusInfo = t('tripStatus.onTime');

    if (stop.isCancelled === '1') {
      // return (
      //   <div className={'delay-status cancelled'}>{t('tripStatus.cancelled')}</div>
      // );
      status = 'cancelled';
      statusInfo = t('tripStatus.cancelled');
    } else {
      if (stop.isStopping !== '1') {
        // return (
        //   <div className={'delay-status'}>{t('tripStatus.notStopping')}</div>
        // );
        statusInfo = t('tripStatus.notStopping');
      } else {
        if (stop.completeInfo) {
          if (stop.completeInfo.delaySecond > goTrackerConfig.minorDelayThreshold.t) {
            const actDeparture = stop.completeInfo.actDeparture;

            if (actDeparture) {
              statusInfo = utils.formatTime(actDeparture, viewStore.isTwentyFourHour);
            } else {
              if (stop.schDeparture) {
                statusInfo = utils.formatTime(stop.schDeparture, viewStore.isTwentyFourHour);
              } else {
                statusInfo = utils.formatTime(stop.completeInfo.actArrival, viewStore.isTwentyFourHour);
              }
            }

            status = 'delayed';
          }
        } else {
          if (tripDelay > goTrackerConfig.minorDelayThreshold.t) {
            const date = new Date();
            const timeArray = stop.schArrival ? stop.schArrival.split(':') : [];

            if (timeArray.length > 0) {
              date.setHours(timeArray[0]);
              date.setMinutes(timeArray[1]);
              date.setSeconds(0);
            }

            const newArrival = addSeconds(date, tripDelay);
            status = 'delayed';
            statusInfo = utils.formatTime(newArrival, viewStore.isTwentyFourHour);
          }
        }
      }
    }

    return (
      <div className={`delay-status ${status}`} aria-describedby={headerCol[3]}>{statusInfo}</div>
    );
  };

  const getTrackNumber = (stop) => {
    if (stop.isCancelled === '1') {
      return (
        <div className="track cancelled" aria-describedby={headerCol[2]}>-</div>
      );
    }

    if (stop.completeInfo && stop.isStopping === '1') {
      if (stop.completeInfo.actArrival || stop.completeInfo.actDeparture) {
        return (
          <div className="track" aria-describedby={headerCol[2]}>
            <span>
              <i className="fa fa-check" />
            </span>
          </div>
        );
      }

      if (stop.completeInfo.actTrack && stop.completeInfo.actTrack !== stop.schTrack) {
        return (
          <div className="track changed " aria-describedby={headerCol[2]}>{stop.completeInfo.actTrack}</div>
        );
      }
    }

    /*//Union station has a platform instead of track from PINS
    if (stop.name === CONSTS.STATION_NAME_UNION) {
      const platform = unionDepartureMessage ? unionDepartureMessage.platform : '-';
      return (
        <div className="track" aria-describedby={headerCol[2]}>{platform}</div>
      );
    }*/

    return (
      <div className="track" aria-describedby={headerCol[2]} >
        {utils.isNullOrEmpty(stop.schTrack) || stop.isStopping === '0' ? '-' : stop.schTrack}
      </div>
    );
  };

  const buildStops = trip => {
    if (!trip) {
      return (
        <li className="departure-row trip no-trip">{t('tripDetail.noData')}</li>
      );
    }

    const estimatedTripDelay = getEstimatedTripDelay(_tripNumber);

    return (
      <React.Fragment>
        {trip.stop.map(stop => {
          const ariaLive = isStationCurrent(stop.name) ? 'polite' : 'off';

          return (
            <li key={stop.id} aria-live={ariaLive} className={`departure-row ${isStationCurrent(stop.name) ? 'current-station' : ''}`}>
              <div className={`data trip ${departureClass}`}>
                <div aria-describedby={headerCol[0]}>
                  {stop.name}
                </div>
                <div aria-describedby={headerCol[1]}>
                  {stop.isStopping === '0' ? (
                    <span>
                      <i className="fa fa-chevron-down" />
                    </span>
                  ) : (
                    utils.formatTime(stop.schArrival, viewStore.isTwentyFourHour)
                  )}
                </div>
                {getTrackNumber(stop)}
                {getDelayTime(stop, estimatedTripDelay)}
              </div>
            </li>
          );
        })}
      </React.Fragment>
    );
  };

  const getExpressIndicator = tripNumber => {
    if (!tripNumber) return null;

    let isExpress = null;

    if (locationStore.messages && locationStore.messages.directions) {
      locationStore.messages.directions.forEach(d => {
        if (d.tripMessages.length < 1) return;

        const trip = d.tripMessages.find(tm => tm.tripName === tripNumber);

        if (trip !== undefined) {
          isExpress = trip.isExpress;
        }
      });
    }

    return isExpress;
  };

  const _direction = props.direction ? props.direction : getDirectionByNumber(props.params.tripNumber);
  const _stationName = locationStore.trip ? utils.formatTripName(locationStore.trip.tripName, viewStore.isTwentyFourHour) : '';
  const _isExpress = props.isExpress ? props.isExpress : getExpressIndicator(props.params.tripNumber);
  const shouldBlink = props.coachCount === props.scheduledCoachCount ? false : true;
  return (
    <main id="main-content">
      <div className="selection">
        {locationStore.trip && (
          <React.Fragment>
            <StationHeader stationName={_stationName} isExpress={_isExpress} isTrain={true}/>
            <TripDirectionHeader direction={_direction} />
            {locationStore.trip && props.coachCount >= 0 && <TagItem value={`${props.coachCount}`} fullWidth blink={shouldBlink} />}
          </React.Fragment>
        )}
        <HeaderColumns className={`departure-header-row trip ${departureClass}`} headerCol={headerCol} />
        {locationStore.isTripLoaded || locationStore.trip ? (
          <ul>{buildStops(locationStore.trip)}</ul>
        ) : (
          <ul>
            <li className="departure-row trip no-trip">
              <i className="fa fa-spinner fa-spin" />
            </li>
          </ul>
        )}
        {locationStore.trip && locationStore.trip.consistDetails.length > 0 && goTrackerConfig.railOccupancy && (<OccupancyDetail tripNumber={_tripNumber} />)}
      </div>
    </main>
  );
});

export default Detail;
